var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0854 1.375H3.01984C2.14199 1.375 1.375 2.00664 1.375 2.87418V18.9754C1.375 19.8477 2.14199 20.625 3.01984 20.625H19.0807C19.9633 20.625 20.625 19.8425 20.625 18.9754V2.87418C20.6302 2.00664 19.9633 1.375 19.0854 1.375ZM7.34207 17.4208H4.58434V8.84641H7.34207V17.4208ZM6.05859 7.54273H6.03883C5.15625 7.54273 4.58477 6.88574 4.58477 6.06332C4.58477 5.22586 5.17129 4.58434 6.07363 4.58434C6.97598 4.58434 7.52813 5.22113 7.54789 6.06332C7.54746 6.88574 6.97598 7.54273 6.05859 7.54273ZM17.4208 17.4208H14.6631V12.7325C14.6631 11.6093 14.2618 10.8419 13.264 10.8419C12.5018 10.8419 12.0506 11.3575 11.8499 11.8598C11.7747 12.0403 11.7545 12.2861 11.7545 12.537V17.4208H8.9968V8.84641H11.7545V10.0396C12.1559 9.46816 12.7828 8.64574 14.2416 8.64574C16.0518 8.64574 17.4212 9.83898 17.4212 12.4115L17.4208 17.4208Z",
    fill: "#CFB57F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLinkedin);
export default __webpack_public_path__ + "static/media/logo-linkedin.f7e5e8691d23e423e975f2158fc7b370.svg";
export { ForwardRef as ReactComponent };